module.exports = __webpack_public_path__ + "static/media/about2.fd270cb4.png";